import { useState } from 'react'
import { BiHelpCircle } from 'react-icons/bi'

function TipComp({ message }: { message: string }) {
  const [showTip, setShowTip] = useState(false)
  return (
    <div>
      <div
        className="tipDiv"
        onMouseEnter={() => setShowTip(true)}
        onMouseLeave={() => setShowTip(false)}
        onFocus={() => {}}
      >
        <BiHelpCircle size="24px" />
      </div>
      <p className={showTip ? 'tipPopup showTip' : 'tipPopup'}>{message}</p>
    </div>
  )
}

export default TipComp
